"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function SensitationReport(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { className: "".concat(className), 
        // height={`${height}`}
        // width={`${width}`}
        width: '40', height: '40', viewBox: '0 0 70 59', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { d: 'M0.901197 0.259561C0.69638 0.396106 0.395981 0.696505 0.259436 0.901323C0.0136545 1.28365 0 2.08926 0 29.1661V57.035L0.314054 57.4992C0.477908 57.7587 0.832925 58.0727 1.09236 58.1956C1.54296 58.4278 3.44094 58.4414 34.9555 58.4414C66.4701 58.4414 68.3681 58.4278 68.8187 58.1956C69.0781 58.0727 69.4332 57.7587 69.597 57.4992L69.9111 57.035V29.1661C69.9111 2.08926 69.8974 1.28365 69.6516 0.901323C69.5151 0.696505 69.2147 0.396106 69.0099 0.259561C68.6275 0.0137798 67.699 0.000125267 34.9555 0.000125267C2.21203 0.000125267 1.28352 0.0137798 0.901197 0.259561ZM11.0601 5.87156V7.64665H7.57825H4.09635V5.87156V4.09648H7.57825H11.0601V5.87156ZM21.9838 5.87156V7.64665H18.6384H15.293V5.87156V4.09648H18.6384H21.9838V5.87156ZM32.9074 5.87156V7.64665H29.562H26.2166V5.87156V4.09648H29.562H32.9074V5.87156ZM43.9675 5.87156V7.64665H40.5539H37.1403V5.87156V4.09648H40.5539H43.9675V5.87156ZM54.8911 5.87156V7.64665H51.5458H48.2004V5.87156V4.09648H51.5458H54.8911V5.87156ZM65.8147 5.87156V7.64665H62.4694H59.124V5.87156V4.09648H62.4694H65.8147V5.87156ZM30.354 20.0859C32.2656 21.0554 42.4655 27.1316 42.8342 27.514C43.749 28.4698 43.749 29.8898 42.8342 30.832C42.3563 31.3372 30.7499 38.1645 29.8487 38.4785C28.77 38.8472 27.5275 38.4102 26.8311 37.4271L26.4215 36.84L26.3805 29.4529C26.3532 23.0216 26.3668 21.9839 26.558 21.4923C27.1178 20.0176 28.9066 19.3486 30.354 20.0859ZM11.0601 52.5017V54.2085H7.57825H4.09635V52.5017V50.7949H7.57825H11.0601V52.5017ZM21.9838 52.5017V54.2085H18.6384H15.293V52.5017V50.7949H18.6384H21.9838V52.5017ZM32.9074 52.5017V54.2085H29.562H26.2166V52.5017V50.7949H29.562H32.9074V52.5017ZM43.9675 52.5017V54.2085H40.5539H37.1403V52.5017V50.7949H40.5539H43.9675V52.5017ZM54.8911 52.5017V54.2085H51.5458H48.2004V52.5017V50.7949H51.5458H54.8911V52.5017ZM65.8147 52.5017V54.2085H62.4694H59.124V52.5017V50.7949H62.4694H65.8147V52.5017Z', fill: 'white' })));
}
SensitationReport.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
SensitationReport.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = SensitationReport;
